<template>
    <div class="vx-col md:w-full sm:w-auto" style="width: 300px !important;">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top" v-if="params.data.status">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.approved')" position="top"
                        v-if="params.data.status === 1">
                <feather-icon icon="CheckIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 text-success cursor-pointer" @click="confirmCompleteRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.rejected')" position="top"
                        v-if="params.data.status === 1">
                <feather-icon icon="XIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 text-danger cursor-pointer"
                              @click="openPopupcancel"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo popup_cancel" title="Xác nhận lý từ chối" :active.sync="popupCancel">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-textarea v-model="rejectReason"/>
                </div>
                <div class="vx-col w-full">
                    <div class="flex float-right">
                        <vs-button class="mr-2" color="danger" iconPack="feather" icon="icon-check"
                                   @click="cancelRecord">{{
                                $t('button.confirm')
                            }}
                        </vs-button>
                        <vs-button class="" color="danger" type="border" iconPack="feather" icon="icon-x"
                                   @click="popupCancel = false">{{ $t('button.cancel') }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import {en, vi} from "vuejs-datepicker/dist/locale";

export default {
    name: 'CellRendererActions',

    data() {
        return {
            popupCancel: false,
            rejectReason: null,
            popupConfirm: false,
            en: en,
            vi: vi,
            selectDate: new Date(),
            selectTime: new Date(),
        }
    },

    methods: {
        editRecord() {
            this.$router.push(`/user/posts-info?id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: 'Bạn có chắc là muốn xóa bài viết này không?',
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            const url = this.params.data.status ? '/beauty-news-feed/delete/' : '/beauty-foul-keyword/delete/';
            this.$crm.get(url + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Xoá thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('DELETE_NEWS_FEED', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        openPopupcancel() {
            this.popupCancel = true;
            this.rejectReason = null;
        },
        cancelRecord() {
            this.$vs.loading();
            this.$crm.post(`/beauty-news-feed/change-status/${this.params.data.id}`, {rejectReason: this.rejectReason ,status: 3}).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Từ chối bài viết thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.popupCancel = false;
                this.$store.commit('DELETE_NEWS_FEED', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        confirmCompleteRecord() {
            this.popupConfirm = true;
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Xác nhận hoàn thành',
                text: 'Bạn có chắc chắn muốn duyệt bài viết này không?',
                accept: this.completeRecord,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },

        completeRecord() {
            this.$vs.loading();
            this.$crm.post(`/beauty-news-feed/change-status/${this.params.data.id}`, {status: 2}).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Đã duyệt bài viết!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('DELETE_NEWS_FEED', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
    }
}
</script>

<style scoped></style>

